import Cafe from './Cafe'

export default Cafe



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/Cafe/index.js